export default __webpack_public_path__ + "static/media/treat-yourself-1024w.efb38c57.png";